import { useEffect, useState } from "react";
import { axiosInstance } from "../../services/axios";


interface Recommendation {
  score: number;
  scoreReason?: string;
  isImportantLLMJudgement: boolean;
  isImportantLLMJudgementReason?: string;
  isImportantContextual: boolean;
  isImportantContextualReason?: string;
  segregate: string;
  segregateReason?: string;
}

export const useIssueRecommendation = (issueId?: string) => {
  const [loading, setLoading] = useState(true);
  const [submittingFeedback, setSubmittingFeedback] = useState(false);
  const [recommendation, setRecommendation] = useState<Recommendation | undefined>();
  const [comment, setComment] = useState<string | null>(null);
  const [selected, setSelected] = useState<"up" | "down" | null>(null);
  const [response, setResponse] = useState<string | null>(null);

  useEffect(() => {
    if (!issueId) return;

    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`/issues/${issueId}/recommendation`);
        const data = response.data;

        if ("isImportant" in data && data.isImportant !== null) {
          setSelected(data.isImportant ? "up" : "down");
        }

        setComment(data?.comment ?? null);
        setRecommendation(data?.aiRecommendation || {});
      } catch (error) {
        console.error("Error fetching issue recommendation:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [issueId]);

  const submitFeedback = async (isImportant: boolean, commentText?: string) => {
    setResponse(null);
    setSubmittingFeedback(true);
    try {
      await axiosInstance.put(`/issues/${issueId}/recommendation`, {
        isImportant,
        comment: commentText ?? comment,
      });
      setSelected(isImportant ? "up" : "down");
      setResponse("Feedback submitted successfully.");
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setResponse("Error processing AI feedback.");
    } finally {
      setSubmittingFeedback(false);
    }
  };

  return {
    loading,
    recommendation,
    comment,
    selected,
    response,
    submittingFeedback,
    setComment,
    setSelected,
    submitFeedback,
  };
};